import { createSelector } from "reselect";

const homeDataSelector = (state) => state.home;

const resultSelector = createSelector(homeDataSelector, (payload) => {
  return {
    loading: payload.get("loading"),
    userProfile: payload.get("userProfile"),
    setting: payload.get("setting"),
    allUsers: payload.get("allUsers"),
    userCount: payload.get("userCount"),
    inputUserSearchValue: payload.get("inputUserSearchValue"),
    loadingSearchUsers: payload.get("loadingSearchUsers"),
    searchedUsers: payload.get("searchedUsers"),
    totalUsers: payload.get("totalUsers"),
    userShow: payload.get("userShow"),
    visibleProfileUser: payload.get("visibleProfileUser"),
    firstRedirect: payload.get("firstRedirect"),
    redirectHome: payload.get("redirectHome"),
    renewMembershipStatus: payload.get("renewMembershipStatus"),
    searchUsers: payload.get("searchUsers"),
    licences: payload.get("licences"),
    licencesPays: payload.get("licencesPays"),
    activityStatus: payload.get("activityStatus"),
  };
});

export const homeSelector = (state) => ({
  ...resultSelector(state),
});
